<template>
  <div class="row my-1">
    <div :class="quiz.type === 'quiz' ? 'col-7 pl-0' : 'col-12 pl-0'">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-9">
              <h3 class="h5">{{quiz.type === 'quiz' ? '문제 ' + (quiz.index + 1) : '공지' }} :
                {{quiz.type === 'quiz' ? quiz.question : quiz.title }}</h3>
              <p class="mb-0">{{quiz.type === 'quiz' ? '정답: ' + (quiz.answer + 1) : ' '}}</P>
            </div>
            <div class="col-3 d-flex justify-content-end">
              <b-btn class="mx-2"
                     :variant="quiz.type === 'quiz' ? 'primary' : 'success'"
                     :disabled="quiz.type !== 'quiz' || quiz.status !== 'ready'"
                     @click="showQuizModal(quiz)">
                수정
              </b-btn>
              <b-btn :variant="quiz.type === 'quiz' ? 'primary' : 'success'"
                     :disabled="!canSubmit || quiz.status !== 'ready'"
                     @click="sendQuiz(quiz)">
                {{quiz.type === 'quiz' ? '제출' : '전송'}}
              </b-btn>
            </div>
          </div>
        </div>
        <div class="card-body">
          {{quiz.type === 'quiz' ? '' : quiz.value}}
          <b-list-group-item
            v-for="s in quiz.selection"
            :key="s">
            {{s}}
          </b-list-group-item>
        </div>
      </div>
    </div>

    <div class="col-5 pl-0" v-if="quiz.type === 'quiz'">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-7">
              <h3 class="h5">결과</h3>
              <p class="mb-0">정답자: {{ rightAnswer }}</P>
            </div>
            <div class="col-5 d-flex justify-content-end">
              <b-btn class="mx-2"
                     variant="primary"
                     :disabled="!canScoring"
                     @click="sendAnswer(true)">
                모두정답
              </b-btn>
              <b-btn variant="primary"
                :disabled="!canScoring"
                @click="sendAnswer()">
                채점
              </b-btn>
            </div>
          </div>
        </div>
        <div class="card-body">
          <b-list-group-item>
            {{ selectCount.s0 }}
          </b-list-group-item>
          <b-list-group-item>
            {{ selectCount.s1 }}
          </b-list-group-item>
          <b-list-group-item>
            {{ selectCount.s2 }}
          </b-list-group-item>
        </div>
      </div>
    </div>

    <b-modal
      id="notNextQuizSend"
      ref="notNextQuizSend"
      centered>
      서버에서 채점 연산이 완료되지 않았습니다. 잠시후 다시시도 하세요.
    </b-modal>
    <b-modal
      id="notQuizSend"
      ref="notQuizSend"
      centered>
      지금은 퀴즈를 제출 할 수 없는 상태입니다.
    </b-modal>

    <b-modal
      @cancel="handleCancel"
      @ok="handleOk"
      id="changeQuiz"
      ref="changeQuiz"
      title="퀴즈 수정"
      centered>
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        label="문제">
        <b-form-input
          v-model="mQuiz.question"
          type="text">
        </b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        label="정답">
        <b-form-input
          v-model="humanReadableAnswer"
          type="number">
        </b-form-input>
      </b-form-group>
      <div>
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          label="보기">
          <b-form-group>
            <b-form-input
              v-model="mQuiz.selection[0]"
              type="text">
            </b-form-input>
            <b-form-input
              v-model="mQuiz.selection[1]"
              type="text">
            </b-form-input>
            <b-form-input
              v-model="mQuiz.selection[2]"
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form-group>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// import * as _ from 'ramda'
// import l from '@/vendor/logger'

export default {
  name: 'QuizzesItem',
  props: {
    quiz: Object,
    number: Number
  },
  data () {
    return {
      submitted: false,
      scored: false,
      submitBtnDisbled: true,
      answerBtnDisabled: true,
      rightAnswer: 0,
      selectCount: { s0: 0, s1: 0, s2: 0 },
      mQuiz: {
        question: '', selection: [], answer: 0, status: '', type: 'quiz'
      }
    }
  },
  watch: {
    currentQuiz () {
      if (this.currentQuiz) {
        this.answerBtnDisabled = false
      } else {
        this.answerBtnDisabled = true
      }
    },
    numberOfRight () {
      if (this.quiz) {
        if (this.numberOfRight[this.number]) {
          // this.rightAnswer = this.numberOfRight[this.number]
          // this.rightAnswer = 0
        }
      }
    },
    numberOfSelect () {
      if (this.quiz) {
        const numberOfSelect = this.numberOfSelect['.value']
        if (numberOfSelect && numberOfSelect.length > 0) {
          numberOfSelect.forEach(v => {
            if (this.quiz.refIndex === v.refIndex) {
              this.selectCount = v
              this.rightAnswer = this.selectCount[`s${this.quiz.answer}`]
            }
          })
        }
      }
    }
  },
  methods: {
    sendQuiz (quiz) {
      if (this.room.status === 'LIVE' || this.room.status === 'QUIZ') {
        // currentQuiz.status는 퀴즈 결과 연산이 모두 끝났을때를 의미함
        if (this.currentQuiz && !this.currentQuiz.status) {
          this.$refs.notNextQuizSend.show()
        } else {
          this.submitted = true
          this.$store.dispatch('quizzes/sendQuiz', quiz)
        }
      } else {
        this.$refs.notQuizSend.show()
      }
    },
    showQuizModal (quiz) {
      this.mQuiz = {
        question: quiz.question, selection: [...quiz.selection], answer: quiz.answer, status: quiz.status, type: 'quiz', refIndex: quiz.refIndex
      }
      this.$refs.changeQuiz.show()
    },
    modifyQuiz (quiz) {
      if (this.room.status === 'LIVE' || this.room.status === 'QUIZ') {
        if (quiz.status && quiz.status === 'ready') {
          this.$store.dispatch('quizzes/modifyQuiz', quiz)
        }
      } else {
        this.$refs.notQuizSend.show()
      }
    },
    sendAnswer (isAll = false) {
      this.scored = true
      this.$store.dispatch('quizzes/sendRightAnswer', isAll)
    },
    handleCancel (evt) {
    },
    handleOk (evt) {
      this.modifyQuiz(this.mQuiz)
    }
  },
  computed: {
    ...mapState('quizzes', [
      'numberOfRight',
      'numberOfSelect'
    ]),
    ...mapGetters('quizzes', [
      'currentQuiz'
    ]),
    ...mapState('room', [
      'room'
    ]),
    isCurrentQuiz () {
      if (this.currentQuiz) {
        return this.quiz.refIndex === this.currentQuiz.refIndex
      } else {
        return false
      }
    },
    canSubmit () {
      return (this.room.status === 'LIVE' || this.room.status === 'QUIZ') && !this.submitted && (this.room.quizStatus === 'READY' || this.room.quizStatus === undefined)
    },
    canScoring () {
      return (this.room.status === 'LIVE' || this.room.status === 'QUIZ') && this.submitted && !this.scored
    },
    humanReadableAnswer: {
      get () { return this.mQuiz.answer + 1 },
      set (x) { this.mQuiz.answer = x - 1 }
    }
  },
  components: {
  }
}
</script>

<style scoped>

</style>(
